/**
 * <juro-outcomes>: arrow buttons for the outcome card rail
 * ------------------------------------------------------------------
 * The rail is native horizontal scroll with scroll-snap, so touch, trackpad
 * and keyboard already work. This only makes the two arrows scroll it by one
 * card, and disables each arrow at its end.
 */

(() => {
  if (customElements.get('juro-outcomes')) return;

  class JuroOutcomes extends HTMLElement {
    connectedCallback() {
      if (this.rail) return;
      this.rail = this.querySelector('.juro-out__rail');
      this.arrows = [...this.querySelectorAll('.juro-out__arrow')];
      if (!this.rail) return;

      this.update = this.update.bind(this);
      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = this.rail.querySelector('.juro-out__card');
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
          const step = card ? card.getBoundingClientRect().width + gap : this.rail.clientWidth * 0.8;
          this.rail.scrollBy({ left: step * Number(btn.dataset.dir), behavior: 'smooth' });
        });
      });
      this.rail.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update, { passive: true });
      this.update();
    }

    update() {
      const max = this.rail.scrollWidth - this.rail.clientWidth - 2;
      const [prev, next] = this.arrows;
      if (prev) prev.disabled = this.rail.scrollLeft <= 2;
      if (next) next.disabled = this.rail.scrollLeft >= max;
      this.toggleAttribute('data-static', max <= 0);
    }
  }

  customElements.define('juro-outcomes', JuroOutcomes);
})();
